import { Pipe, PipeTransform } from '@angular/core';

import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/min';

@Pipe({
    name: 'formatPhoneNumber',
    standalone: true
})
export class FormatPhoneNumberPipe implements PipeTransform {
    transform(value: string | null, countryCode: CountryCode = 'US'): unknown {
        return value ? parsePhoneNumberFromString(value, countryCode)?.formatNational() : null;
    }
}
